import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaBalanceScale, FaStethoscope, FaGavel, FaCalculator, FaChartLine,  FaHandshake } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import styled, { keyframes } from "styled-components";



const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(50px); }
  to { opacity: 1; transform: translateY(0); }
`;

const ServiceCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  margin-bottom: 30px;
  animation: ${fadeUp} 0.5s ease-in-out forwards;
  animation-delay: ${({ delay }) => delay || "0s"};
  height: 100%;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  }
`;

const ServiceIcon = styled.div`
  font-size: 42px;
  color: ${props => props.color || "#ffc107"};
  margin-bottom: 20px;
`;

const ServiceTitle = styled.h4`
  font-weight: 700;
  margin-bottom: 15px;
  color: #333;
`;

const ServiceDescription = styled.p`
  color: #666;
  font-size: 16px;
  line-height: 1.6;
`;


const Section = styled.section`
  padding: 80px 0;
  background: ${props => props.background || "white"};
`;

const ServiceListItem = styled.div`
  display: flex;
  margin-bottom: 15px;
  opacity: 0;
  transform: translateY(30px);
  animation: ${fadeUp} 0.6s ease-in-out forwards;
  animation-delay: ${({ delay }) => delay || "0s"};
`;

const ServiceListIcon = styled.div`
  margin-right: 15px;
  color: #008a44;
  flex-shrink: 0;
  margin-top: 3px;
`;

const ServiceListContent = styled.div`
  flex-grow: 1;
`;

const ServiceListTitle = styled.h5`
  font-weight: 700;
  margin-bottom: 5px;
  color: #333;
`;

const ServiceListDescription = styled.p`
  color: #666;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 0;
`;

const ProfessionLiberale = () => {

    const [ setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const faqSection = document.getElementById("faq-section");
            if (faqSection) {
                const rect = faqSection.getBoundingClientRect();
                if (rect.top < window.innerHeight * 0.8 && rect.bottom > 0) {
                    setIsVisible(true);
                } else {
                    setIsVisible(false);
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    

    

    const servicesData = [
        {
            icon: <FaCalculator />,
            title: "Comptabilité et Fiscalité",
            description: "Tenue complète de votre comptabilité, établissement de vos déclarations fiscales, optimisation de votre situation fiscale et assistance en cas de contrôle.",
            color: "#0d6efd"
        },
        {
            icon: <FaChartLine />,
            title: "Gestion et Pilotage",
            description: "Tableaux de bord personnalisés, analyse de rentabilité, prévisionnel d'activité et optimisation de votre trésorerie pour mieux piloter votre activité.",
            color: "#198754"
        },
        {
            icon: <FaHandshake />,
            title: "Conseil et Accompagnement",
            description: "Accompagnement personnalisé à chaque étape de votre activité : installation, développement, gestion patrimoniale, préparation à la retraite et transmission.",
            color: "#dc3545"
        }
    ];


    const serviceDetails = {
        comptabilite: [
            {
                title: "Tenue de la comptabilité",
                description: "Saisie de vos recettes et dépenses, gestion des immobilisations, rapprochements bancaires. Nous nous adaptons à votre mode d'exercice (comptabilité de trésorerie ou d'engagement)."
            },
            {
                title: "Déclarations fiscales",
                description: "Établissement et télétransmission de votre déclaration de Bénéfices Non Commerciaux, en optimisant votre situation fiscale."
            },
            {
                title: "Gestion de la TVA",
                description: "Gestion de votre TVA (si vous y êtes assujetti), déclarations et télétransmissions."
            },
            {
                title: "Conseil fiscal personnalisé",
                description: "Optimisation de votre fiscalité (choix du régime fiscal, déductions, crédits d'impôt, etc.)."
            },
            {
                title: "Assistance en cas de contrôle fiscal",
                description: "Accompagnement complet et défense de vos intérêts."
            },
            {
                title: "Gestion de la paie",
                description: "Établissement des bulletins de paie et des déclarations sociales."
            },
            {
                title: "Passage en société",
                description: "Analyse de l'opportunité, accompagnement dans les formalités, et suivi comptable et fiscal de la société."
            }
        ],
        gestion: [
            {
                title: "Tableaux de bord personnalisés",
                description: "Suivi de vos indicateurs clés de performance (chiffre d'affaires, charges, résultat, trésorerie, etc.)."
            },
            {
                title: "Analyse de rentabilité",
                description: "Identification des points forts et des axes d'amélioration de votre activité."
            },
            {
                title: "Prévisionnel d'activité",
                description: "Élaboration de budgets prévisionnels pour anticiper vos besoins et vos ressources."
            },
            {
                title: "Gestion de trésorerie",
                description: "Optimisation de votre trésorerie, anticipation des échéances."
            },
            {
                title: "Conseil en financement",
                description: "Recherche de solutions de financement pour vos projets (investissement, développement, etc.)."
            }
        ],
        conseil: [
            {
                title: "Accompagnement à l'installation",
                description: "Choix du statut juridique, formalités d'installation, business plan, recherche de financements."
            },
            {
                title: "Conseil en gestion patrimoniale",
                description: "Optimisation de votre patrimoine professionnel et personnel (en collaboration avec des partenaires spécialisés si nécessaire)."
            },
            {
                title: "Préparation de la retraite",
                description: "Bilan retraite, optimisation de vos droits, stratégies de départ."
            },
            {
                title: "Transmission d'activité",
                description: "Évaluation de votre cabinet/clientèle, accompagnement dans la cession ou la transmission."
            },
            {
                title: "Conseil en organisation",
                description: "Optimisation de vos processus administratifs, gestion du temps, digitalisation de vos outils."
            },
            {
                title: "Conseil juridique",
                description: "Contrats, baux professionnels, etc. (en partenariat avec des avocats, si applicable)."
            }
        ]
    };

    return (
        <>
            <Header />

            <section className="service-banner d-flex align-items-center">
                <div className="container-fluid px-4 px-md-5 text-white">
                    <div className="row">
                        <div className="col-lg-8">
                            <h1 className="fw-bold display-4 mb-3">Expertise Comptable et Conseil pour les Professions Libérales</h1>
                            <p className="fs-5 mb-4">Concentrez-vous sur votre activité, nous gérons vos obligations</p>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/" className="text-white text-decoration-none">
                                            Accueil
                                        </Link>{" "}
                                        /{" "}
                                        <Link to="/services" className="text-white text-decoration-none">
                                            Services
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active text-white" aria-current="page">
                                        Professions Libérales
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>

            <Section>
                <div className="container-fluid px-4 px-md-5">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="fw-bold custom-title text-center mb-5">
                                CINEF-EC comprend les enjeux spécifiques des professions libérales
                            </h2>
                            <p className="text-muted text-center fs-5 mb-5">
                                Vous êtes médecin, avocat, architecte, consultant, ou exercez une autre profession libérale ? Votre temps est précieux et doit être consacré à vos clients/patients et à votre cœur de métier. CINEF-EC vous libère des contraintes administratives, comptables et fiscales, et vous apporte un accompagnement personnalisé pour optimiser la gestion et le développement de votre activité.
                            </p>
                        </div>
                    </div>

                    <div className="row align-items-center">
                       
                        <div className="col-lg-12">
                            <h3 className="fw-bold custom-title mb-4">Une expertise dédiée aux professions libérales</h3>
                            <p className="mb-4">
                                Notre cabinet dispose d'une expertise particulière dans l'accompagnement des professions libérales. Nous connaissons parfaitement les spécificités comptables, fiscales et juridiques de votre secteur d'activité.
                            </p>
                            <p className="mb-4">
                                Notre objectif est double : vous décharger des contraintes administratives pour vous permettre de vous concentrer sur votre cœur de métier, et vous accompagner stratégiquement pour optimiser votre activité et votre patrimoine.
                            </p>
                            <div className="d-flex mt-4">
                                <div className="d-flex align-items-center me-4">
                                    <div className="rounded-circle bg-success d-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                                        <FaStethoscope className="text-white fs-4" />
                                    </div>
                                    <span className="ms-2 fw-bold">Professions de santé</span>
                                </div>
                                <div className="d-flex align-items-center me-4">
                                    <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                                        <FaGavel className="text-white fs-4" />
                                    </div>
                                    <span className="ms-2 fw-bold">Professions juridiques</span>
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="rounded-circle bg-danger d-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                                        <FaBalanceScale className="text-white fs-4" />
                                    </div>
                                    <span className="ms-2 fw-bold">Consultants</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Section>

            <Section background="#f8f9fa">
                <div className="container-fluid px-4 px-md-5">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="fw-bold mb-1">Nos services pour les professions libérales</h2>
                            <div className="d-inline-block mb-4">
                                <div className="custom-underline mx-auto"></div>
                            </div>
                            <p className="text-muted fs-5 mb-5">Une gamme complète de services adaptés à vos besoins spécifiques</p>
                        </div>
                    </div>

                    <div className="row">
                        {servicesData.map((service, index) => (
                            <div className="col-md-6 col-lg-4 mb-4" key={index}>
                                <ServiceCard delay={`${index * 0.1}s`}>
                                    <ServiceIcon color={service.color}>{service.icon}</ServiceIcon>
                                    <ServiceTitle>{service.title}</ServiceTitle>
                                    <ServiceDescription>{service.description}</ServiceDescription>
                                </ServiceCard>
                            </div>
                        ))}
                    </div>
                </div>
            </Section>

            <Section>
                <div className="container-fluid px-4 px-md-5">
                    <div className="row mb-5">
                        <div className="col-12">
                            <h3 className="fw-bold custom-title mb-4">1. Comptabilité et Fiscalité</h3>
                        </div>
                    </div>

                    <div className="row mb-5">
                        {serviceDetails.comptabilite.map((item, index) => (
                            <div className="col-md-6 mb-4" key={`comptabilite-${index}`}>
                                <ServiceListItem delay={`${index * 0.1}s`}>
                                    <ServiceListIcon>
                                        <i className="fas fa-check-circle fa-lg"></i>
                                    </ServiceListIcon>
                                    <ServiceListContent>
                                        <ServiceListTitle>{item.title}</ServiceListTitle>
                                        <ServiceListDescription>{item.description}</ServiceListDescription>
                                    </ServiceListContent>
                                </ServiceListItem>
                            </div>
                        ))}
                    </div>

                    <div className="row mb-5">
                        <div className="col-12">
                            <h3 className="fw-bold custom-title mb-4">2. Gestion et Pilotage</h3>
                        </div>
                    </div>

                    <div className="row mb-5">
                        {serviceDetails.gestion.map((item, index) => (
                            <div className="col-md-6 mb-4" key={`gestion-${index}`}>
                                <ServiceListItem delay={`${index * 0.1}s`}>
                                    <ServiceListIcon>
                                        <i className="fas fa-check-circle fa-lg"></i>
                                    </ServiceListIcon>
                                    <ServiceListContent>
                                        <ServiceListTitle>{item.title}</ServiceListTitle>
                                        <ServiceListDescription>{item.description}</ServiceListDescription>
                                    </ServiceListContent>
                                </ServiceListItem>
                            </div>
                        ))}
                    </div>

                    <div className="row mb-5">
                        <div className="col-12">
                            <h3 className="fw-bold custom-title mb-4">3. Conseil et Accompagnement</h3>
                        </div>
                    </div>

                    <div className="row mb-5">
                        {serviceDetails.conseil.map((item, index) => (
                            <div className="col-md-6 mb-4" key={`conseil-${index}`}>
                                <ServiceListItem delay={`${index * 0.1}s`}>
                                    <ServiceListIcon>
                                        <i className="fas fa-check-circle fa-lg"></i>
                                    </ServiceListIcon>
                                    <ServiceListContent>
                                        <ServiceListTitle>{item.title}</ServiceListTitle>
                                        <ServiceListDescription>{item.description}</ServiceListDescription>
                                    </ServiceListContent>
                                </ServiceListItem>
                            </div>
                        ))}
                    </div>
                </div>
            </Section>

            <Section>
                <div className="container-fluid px-4 px-md-5">
                    <div className="row justify-content-center mb-5">
                        <div className="col-12 col-md-10 col-lg-8">
                            <div className="call-to-action p-5 rounded-3 text-center">
                                <h3 className="fw-bold text-white mb-3">Vous souhaitez simplifier votre gestion et vous concentrer sur l'essentiel ?</h3>
                                <p className="text-white fs-5 mb-4">
                                    Contactez-nous dès aujourd'hui pour un entretien gratuit et sans engagement. Nous étudierons ensemble vos besoins et vous proposerons une solution personnalisée.
                                </p>
                                <a href="/contact" className="btn btn-light btn-lg fw-bold px-4">Demander un entretien gratuit</a>
                            </div>
                        </div>
                    </div>
                </div>
            </Section>

            <Footer />

            <style>{`
        .service-banner {
          background: linear-gradient(to right, rgba(0, 138, 68, 0.85), rgba(220, 53, 69, 0.85)), 
                      url("/assets/images/profession-liberale-banner.jpg");
          background-size: cover;
          background-position: center;
          height: 400px;
          display: flex;
          align-items: center;
        }

        .breadcrumb {
          background: transparent;
          font-size: 18px;
        }

        .breadcrumb-item a {
          color: white;
          font-weight: 500;
        }

        .custom-title {
          position: relative;
          padding-bottom: 15px;
        }

        .custom-title:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 60px;
          height: 3px;
          background: linear-gradient(to right, #008a44, #dc3545);
        }

        .text-center .custom-title:after {
          left: 50%;
          transform: translateX(-50%);
        }

        .custom-underline {
          height: 4px;
          width: 70px;
          background: linear-gradient(to right, #008a44, #dc3545);
          margin-top: 10px;
        }

        .call-to-action {
          background: linear-gradient(to right, #008a44, #dc3545);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }

        #faq-section {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.8s ease;
        }

        #faq-section.visible {
          opacity: 1;
          transform: translateY(0);
        }
        
        @media (max-width: 768px) {
          .service-banner {
            height: 350px;
          }
          
          .custom-title {
            font-size: 1.75rem;
          }
          
          .d-flex {
            flex-wrap: wrap;
          }
          
          .d-flex .d-flex {
            margin-bottom: 10px;
          }
        }

        .fa-check-circle {
          color: #008a44;
        }
      `}</style>
        </>
    );
};

export default ProfessionLiberale;
